import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SliderInput } from '../../components/forms/SliderInput';
import { useAppContext } from '../../contexts/AppContext';
import { WEIGHT_PROFILES } from '../../data/weightProfiles';
const CARD_STYLE = {
    position: 'relative',
    backgroundColor: '#141414',
    border: '2px solid #333333',
    borderRadius: 0,
    padding: '1rem 1.25rem',
    marginBottom: '0.75rem',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
};
const SECTION_TITLE = {
    fontWeight: '900',
    color: '#999999',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    fontSize: '12px',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
};
const CONTENT_STYLE = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    alignItems: 'center',
};
const HEADER_STYLE = {
    marginBottom: '0.5rem',
    textAlign: 'center',
    maxWidth: '512px',
    width: '100%',
};
const TITLE_STYLE = {
    fontSize: '1.25rem',
    fontWeight: '900',
    color: '#f5f5f5',
    textTransform: 'uppercase',
    letterSpacing: '-0.025em',
    marginBottom: '0.25rem',
};
const SUBTITLE_STYLE = {
    fontSize: '0.875rem',
    color: '#999999',
};
const BUTTON_PRIMARY = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#06b6d4',
    color: '#000000',
    fontWeight: '900',
    border: '2px solid #06b6d4',
    borderRadius: 0,
    padding: '10px 20px',
    fontFamily: 'inherit',
    fontSize: '13px',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    transition: 'all 0.15s ease',
    cursor: 'pointer',
};
const BUTTON_SECONDARY = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    color: '#f5f5f5',
    fontWeight: '900',
    border: '2px solid #333333',
    borderRadius: 0,
    padding: '10px 20px',
    fontFamily: 'inherit',
    fontSize: '13px',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    transition: 'all 0.15s ease',
    cursor: 'pointer',
};
const PROFILE_BUTTON_BASE = {
    width: '100%',
    textAlign: 'left',
    padding: '1rem',
    border: '2px solid',
    borderRadius: 0,
    transition: 'all 0.15s ease',
    cursor: 'pointer',
    backgroundColor: '#141414',
};
const PROFILE_BUTTON_ACTIVE = {
    ...PROFILE_BUTTON_BASE,
    borderColor: '#06b6d4',
    backgroundColor: '#06b6d420',
    color: '#06b6d4',
};
const PROFILE_BUTTON_INACTIVE = {
    ...PROFILE_BUTTON_BASE,
    borderColor: '#333333',
    color: '#f5f5f5',
};
const PROFILE_BUTTON_HOVER = {
    borderColor: '#06b6d4',
    backgroundColor: '#06b6d410',
};
export function ConfigTab() {
    const { activeWeightProfile, updateWeightProfile, updateCustomWeights } = useAppContext();
    const weights = activeWeightProfile.weights;
    const total = Object.values(weights).reduce((a, b) => a + b, 0);
    const handleCustomWeight = (key, value) => {
        const newWeights = { ...weights, [key]: value / 100 };
        const sum = Object.values(newWeights).reduce((a, b) => a + b, 0);
        if (sum > 0) {
            const normalized = Object.entries(newWeights).reduce((acc, [k, v]) => {
                acc[k] = v / sum;
                return acc;
            }, {});
            updateCustomWeights(normalized);
        }
    };
    const weightLabels = {
        imn: 'IMN (Modelo de Negócio)',
        iap: 'IAP (Adequação ao Perfil)',
        icp: 'ICP (Compatibilidade Pessoal)',
        ird: 'IRD (Recursos Disponíveis)',
        ien: 'IEN (Esforço Necessário)',
    };
    const isActive = (profileId) => activeWeightProfile.id === profileId;
    return (_jsxs("div", { style: CONTENT_STYLE, children: [_jsxs("div", { style: HEADER_STYLE, children: [_jsx("h2", { style: TITLE_STYLE, children: "Configura\u00E7\u00F5es" }), _jsx("p", { style: SUBTITLE_STYLE, children: "Ajuste pesos e perfis de decis\u00E3o." })] }), _jsxs("div", { style: CARD_STYLE, children: [_jsx("h3", { style: SECTION_TITLE, children: "PERFIS DE PESO" }), _jsx("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.5rem' }, children: WEIGHT_PROFILES.map(profile => (_jsxs("button", { onClick: () => updateWeightProfile(profile.id), style: isActive(profile.id) ? PROFILE_BUTTON_ACTIVE : PROFILE_BUTTON_INACTIVE, onMouseEnter: (e) => {
                                if (!isActive(profile.id)) {
                                    Object.assign(e.currentTarget.style, PROFILE_BUTTON_HOVER);
                                }
                            }, onMouseLeave: (e) => {
                                if (!isActive(profile.id)) {
                                    Object.assign(e.currentTarget.style, PROFILE_BUTTON_INACTIVE);
                                }
                            }, children: [_jsx("div", { style: { fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '14px' }, children: profile.name }), _jsx("div", { style: { fontSize: '12px', color: '#999999', marginTop: '4px' }, children: profile.description })] }, profile.id))) })] }), _jsxs("div", { style: CARD_STYLE, children: [_jsx("h3", { style: SECTION_TITLE, children: "PESOS CUSTOMIZADOS" }), _jsxs("p", { style: { fontSize: '12px', color: '#999999', marginBottom: '1rem' }, children: ["Total: ", _jsxs("span", { style: { fontFamily: 'monospace', fontWeight: '900', color: '#fbbf24' }, children: [(total * 100).toFixed(0), "%"] }), " (normaliza automaticamente)"] }), _jsx("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.75rem', width: '100%' }, children: Object.keys(weights).map(key => (_jsx(SliderInput, { id: `${key}_weight`, label: weightLabels[key], value: weights[key] * 100, onChange: (v) => handleCustomWeight(key, v), minLabel: "0%", maxLabel: "100%", className: "brutal-slider" }, key))) })] })] }));
}
